const isCollapsed = {
    isCollapsed: true
}

export default isCollapsed